import { css } from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        form: css`
            ${custom.stepElementPadding};
            ${common.flexJustityAlignCenter};
        `,
        actions: css`
            ${common.flexJustityAlignCenter};
            flex-shrink: 1;
            flex-basis: 0;
        `,
        pictureContainer: css`
            ${common.flexJustityAlignCenter};
            justify-content: center;
            padding-left: 10px;
            flex-shrink: 1;
            flex-basis: 0;
        `,
        pictureContainerLayout: css`
            width: 640px;
            ${common.flexJustityAlignCenter};
            justify-content: center;
            @media (max-width: 1000px) {
                width: 427px;
            }
        `,
        picture: css`
            width: 640px;
            height: 360px;
            @media (max-width: 1000px) {
                width: 427px;
                height: 240px;
            }
        `,
        pictureVr: css`
            width: 207px;
            height: 368px;
            @media (max-width: 1000px) {
                width: 135px;
                height: 240px;
            }
        `,
    }
}

export default styles
